import { IMortgage } from "@/store/modules/mortgage/types";
import defaultsDeep from "lodash/defaultsDeep";
import { cloneDeep } from "lodash";
import { baseMortgage } from "@/helpers/defaultObjects";

export function mortgageDefault(mortgage: Partial<IMortgage>): IMortgage {
  return defaultsDeep(cloneDeep(mortgage), Object.assign(baseMortgage()));
}
